import {
  RestockApi,
  RestockApiGetRestockExternalRequest
} from '@itsrever/rever-api'
import { apiClient } from '@/infrastructure/api'
import { toRestock } from './dto'

const restockApi = new RestockApi(undefined, undefined, apiClient)

async function getRestocks(
  args: RestockApiGetRestockExternalRequest,
  signal?: AbortSignal
) {
  const getProcessResponse = await restockApi.getRestockExternal(args, {
    signal
  })
  return toRestock(getProcessResponse.data.restocks ?? [])
}

export default { getRestocks }
